<script>
import Layout from '@layouts/main'
import SearchBar from '@components/search/search-bar'

const RECENT_SEARCH_OPTIONS = ['artist', 'genre', 'mix', 'show']

export default {
    components: { Layout, SearchBar },
    page() {
        const title = 'Search'
        const description = 'Search FRISKY for mixes, shows, artists, and genres.'
        const image = `${process.env.VUE_APP_CLIENT_URL}/frisky-social-share-image.png`
        const canonicalUrl = `https://frisky.fm${this.$route.path}`
        return {
            title,
            link: [{ rel: 'canonical', vmid: 'canonical', href: canonicalUrl }],
            meta: [
                { name: 'title', vmid: 'title', content: title },
                { name: 'description', vmid: 'description', content: description },

                { property: 'og:title', vmid: 'og:title', content: title },
                { property: 'og:description', vmid: 'og:description', content: description },
                { property: 'og:image', vmid: 'og:image', content: image },
                { property: 'og:type', vmid: 'og:type', content: 'website' },
                { property: 'og:url', vmid: 'og:url', content: canonicalUrl },
                { property: 'og:site_name', vmid: 'og:site_name', content: 'FRISKY' },

                { name: 'twitter:card', vmid: 'twitter:card', content: 'summary_large_image' },
                { name: 'twitter:title', vmid: 'twitter:title', content: title },
                { name: 'twitter:description', vmid: 'twitter:description', content: description },
                { name: 'twitter:image', vmid: 'twitter:image', content: image },
                { name: 'twitter:url', vmid: 'twitter:url', content: canonicalUrl },
            ],
        }
    },
    computed: {
        searchKeyword() {
            return this.$store.state.search.keyword
        },
    },
    watch: {
        searchKeyword() {
            if (this.searchKeyword) {
                this.$router.push({
                    name: this.$route.name.includes('search/results') ? this.$route.name : 'search/results/top',
                    params: { keyword: this.searchKeyword.replace(/ /g, '_') },
                })
            } else {
                this.$router.push({ name: 'search' })
            }
        },
    },
    beforeRouteLeave(to, from, next) {
        if (RECENT_SEARCH_OPTIONS.indexOf(to.name) > -1 && !to.query.back) {
            const item = {
                id: `${to.name}-${to.params.id}`,
                type: to.name,
                itemId: to.params.id,
            }
            this.$dataLayer.search.addToRecent(item)
        }
        next()
    },
}
</script>

<template>
    <Layout :hide-mobile-menu-bar="true">
        <!-- Mobile-only search bar positioned as header (hidden on desktop) -->
        <SearchBar :class="$style.mobileSearchBar" />
        <BaseContent :class="$style.searchArea">
            <transition
                name="fade"
                mode="out-in"
            >
                <router-view />
            </transition>
        </BaseContent>
    </Layout>
</template>

<style lang="scss" module>
@import '@design';

.searchArea {
    min-height: calc(100vh - #{$size-music-player} - #{$size-search-bar-height});

    @include desktop {
        min-height: calc(100vh - #{$size-music-player});
    }
}

.mobileSearchBar {
    position: sticky;
    top: 0;
    z-index: $layer-dropdown-z-index;

    @include desktop {
        display: none;
    }
}
</style>
